import boletaApi from "./boletaApi";

export const getCompanies = async () => {
  try {
    return await boletaApi.get("/getCompanies");
  } catch (error) {
    const { response } = error;
    return response;
  }
};
